export const SET_TASKS_LIST = "SET_TASKS_LIST";
export const SET_TASK_MATURITY_QUES = "SET_TASK_MATURITY_QUES";
